import React from "react";
import styled from "styled-components";
import Button from "../../buttons/Button";
import {
    MELOGY_BLACK,
    MELOGY_WHITE,
} from "../../../style/colors";
import { 
    getIcon, 
} from "../../../util/StyleSettingsUtil"

const ButtonsBackground = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const GroupButtonsContainer = styled.div`
    margin-top: 0;
    margin-bottom: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: transparent;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    border-radius: 0;
    padding: 0;
    gap: 0;
`;

const GroupSelection = ({ selectedStyle, handleSelectGroup, allowedGroups }) => {
    // Always use white text/icons for better readability with dark backgrounds
    const buttonColor = "white";
    const color = MELOGY_WHITE;
    const groupedStyleSettings = selectedStyle.reduce((acc, setting) => {
        const group = setting.group || "Misc.";
        if (!acc[group]) acc[group] = [];
        acc[group].push(setting);
        return acc;
    }, {});

    const groupsToShow = Object.keys(groupedStyleSettings).filter((groupName) => {
        if (groupName === "Misc.") return false; // Filter out "Misc." groups
        if (allowedGroups && !allowedGroups.includes(groupName)) return false; // Filter by allowedGroups if provided
        return true;
    }).sort((a, b) => {
        // Ensure Background comes before Instruments
        if (a === "Background" && b === "Instruments") return -1;
        if (a === "Instruments" && b === "Background") return 1;
        return 0;
    });

    return (
        <ButtonsBackground>
            <GroupButtonsContainer>
                {groupsToShow.map((groupName) => (
                    <Button
                        key={groupName}
                        text={groupName}
                        height="32px"
                        width="100%"
                        justifyContent="flex-start"
                        buttonColor={buttonColor}
                        borderBottom="0"
                        onClick={() => handleSelectGroup(groupName)}
                        icon={getIcon(groupName, color)}
                        transparentBackground={true}
                    />
                ))}
            </GroupButtonsContainer>
        </ButtonsBackground>
    );
};

export default GroupSelection;
